import { inject } from '@angular/core';
import { NavigationServiceadmin } from 'app/core/navigation/navigation.service-admin';
import { forkJoin } from 'rxjs';

export const initialDataResolveradmin = () => {
    const navigationService = inject(NavigationServiceadmin);

    // Only load critical navigation data - other services load asynchronously in components
    return forkJoin([
        navigationService.get(),
    ]);
};
